import { useMutation, useQueryClient } from "@tanstack/react-query"
import { reviseSellerQuotation, type ReviseQuotationPayload } from "@/lib/api/quotation.api"
import { useAuthStore } from "@/store/auth.store"

interface ReviseArgs {
  id: string
  payload: ReviseQuotationPayload
}

export function useReviseQuotation() {
  const accessToken = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, payload }: ReviseArgs) => {
      if (!accessToken) throw new Error("Not authenticated")
      return reviseSellerQuotation(id, payload, accessToken)
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["seller-quotations"] })
    },
  })
}
